import React, {useState, useEffect} from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import sparkLogo from "./Images/spark.png";
import databrickslogo from "./Images/databricks.jpg";
import pythonLogo from "./Images/python.png";
import sqlLogo from "./Images/sql.jpg";
import reactlogo from "./Images/react.jpg";
import nodelogo from "./Images/nodejs.png";
import expresslogo from "./Images/express.png";
import mongologo from "./Images/mongo.png";
import ejslogo from "./Images/ejs.png";
import { IoIosArrowDown } from "react-icons/io";

//CSS in Tech.css

function Techcard(props){

    const [screenWidth, setScreenWidth] = useState(getCurrentDimension());

    const [showDesc, setShowDesc] = useState(false);

  	function getCurrentDimension(){
    	return  window.innerWidth;
  	}
  
  	useEffect(() => {
    		const updateDimension = () => {
      			setScreenWidth(getCurrentDimension())
    		}
    		window.addEventListener('resize', updateDimension);
    		
    		return(() => {
        		window.removeEventListener('resize', updateDimension);
    		})
  	}, [screenWidth])

      function handleClick(){
          setShowDesc(!showDesc);
      }

    function handlelogo(){
        if(props.name==="React")
            return reactlogo;
        else if(props.name==="Node.js")
            return nodelogo;
        else if(props.name==="Express.js")
            return expresslogo;
        else if(props.name==="MongoDB")
            return mongologo;
        else if(props.name==="EJS")
            return ejslogo;
        else if(props.name==="Apache Spark")
            return sparkLogo;
        else if(props.name==="Databricks")
            return databrickslogo;
        else if(props.name==="Python")
            return pythonLogo;
        else if(props.name==="SQL")
            return sqlLogo;
    }

    function Expandedbox() {
        return(
            <div>
                <Card.Text>{props.description}</Card.Text>
                <Button variant="outline-primary" className="card-button" href={props.link} target="_blank">Learn More</Button>
            </div>
        );
    }

    return(
        <Card className="card-tile" onClick={handleClick}>
            <Card.Img className="card-img" variant="top" src={handlelogo()} />
            <Card.Body>
                <Card.Title style={{marginBottom:!(screenWidth>767||showDesc)&&0.4+'rem'}}>{props.name}</Card.Title>
                {(screenWidth>767||showDesc)?Expandedbox():<IoIosArrowDown />}
            </Card.Body>
        </Card>
    );
}

export default Techcard;